import { join } from "lodash";
import * as React from "react";
import { Lightbox } from "../../../../../../react-core/Html/Components/Lightbox";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";
import { ServiceValidationError } from "../../../../../../Wrap/Core/DataTypes/ServiceValidation/ServiceValidationError";
import { CustomerMergeModel } from "../../../../../../Wrap/Models/Models/Customer/CustomerMergeModel";
import { CheckboxGroup } from "../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { checkPermission } from "../../../../../Shared/Permission/PermissionHelper";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Urls } from "../../../../Urls";
import { CustomerMergeAction } from "../Action/CustomerMergeAction";
import { doCompare, switchTypes, validateActiveUsers, validateAMLCheckStatus } from "../Resource/CustomerMergeHelper";

interface IDeclarationsProps {
    data: CustomerMergeModel;
    customerSelected: Array<number>;
}

const submitMerge = (data: CustomerMergeModel, setIsSubmit) => {
    let validateResult = [];
    // validate customer-details
    validateResult = validateResult.concat(
        doCompare(switchTypes("customer-details"), data?.FirstCustomer, data?.SecondCustomer)
    );
    // validate customer-details
    validateResult = validateResult.concat(
        doCompare(switchTypes("contact-information"), data?.FirstCustomer, data?.SecondCustomer)
    );
    // validate customer-details
    validateResult = validateResult.concat(
        doCompare(switchTypes("addresses"), data?.FirstCustomer, data?.SecondCustomer)
    );
    // validate customer-details
    validateResult = validateResult.concat(
        doCompare(switchTypes("regulatory"), data?.FirstCustomer, data?.SecondCustomer)
    );
    // validate customer-details
    validateResult = validateResult.concat(
        doCompare(switchTypes("regulatory-checks"), data?.FirstCustomer, data?.SecondCustomer)
    );

    const isAllMatch = validateResult?.findIndex((e) => e === false); // > 0 means false, -1 means true
    if (isAllMatch >= 0) {
        setIsSubmit({
            isShow: true,
            msg: "All data from customers 1 and 2 must be matching before this process can be completed.",
            title: "Error",
            isReload: false,
        });
        return;
    }

    // validate user id
    if (!validateActiveUsers(data?.FirstCustomer?.ActorUserId, data?.SecondCustomer?.ActorUserId)) {
        setIsSubmit({
            isShow: true,
            msg:
                "Cannot submit process as the selected customers have >1 active user for the platform. Please ensure there is only 1 or 0 users tied to these customers in order to submit. Please refer to the adviser if this needs further clarification.",
            title: "Error",
            isReload: false,
        });
        return;
    }

    // validate AML check statu
    const result = validateAMLCheckStatus(data?.FirstCustomer, data?.SecondCustomer);
    if (result.length !== 0) {
        const _string = join(result, ",");
        setIsSubmit({
            isShow: true,
            msg: `Please re-run the AML checks for the following customer as they have been flagged for not passing their latest AML check: ${_string}`,
            title: "Error",
            isReload: false,
        });
        return;
    }

    setIsSubmit({
        isShow: true,
        msg: (
            <div>
                <p>Are you sure you wish to submit?</p>
                <p>
                    <b>PLEASE NOTE</b>: Submitting this wizard will complete the following actions
                </p>
                <p>
                    <ul className="bullet-list">
                        <li>Persist the selected customer and remove the unselected customer</li>
                        <li>Delete the unselected customers user</li>
                    </ul>
                </p>
            </div>
        ),
        title: "Submit",
        isReload: false,
    });
};

const submit = (customerSelected, setIsSubmit, setIsBusy) => {
    const selectedCustomer = customerSelected[0];
    let fromCustomer, toCustomer;
    const customerId1 = getQueryParameters()["customerid1"];
    const customerId2 = getQueryParameters()["customerid2"];
    if (selectedCustomer == 1) {
        fromCustomer = customerId2;
        toCustomer = customerId1;
    } else {
        fromCustomer = customerId1;
        toCustomer = customerId2;
    }

    // Get data again and check
    CustomerMergeAction.getCustomerMerge(customerId1, customerId2, (res) => {
        // Do the comparison
        let validateResult = [];
        // validate customer-details
        validateResult = validateResult.concat(
            doCompare(switchTypes("customer-details"), res?.FirstCustomer, res?.SecondCustomer)
        );
        // validate customer-details
        validateResult = validateResult.concat(
            doCompare(switchTypes("contact-information"), res?.FirstCustomer, res?.SecondCustomer)
        );
        // validate customer-details
        validateResult = validateResult.concat(
            doCompare(switchTypes("addresses"), res?.FirstCustomer, res?.SecondCustomer)
        );
        // validate customer-details
        validateResult = validateResult.concat(
            doCompare(switchTypes("regulatory"), res?.FirstCustomer, res?.SecondCustomer)
        );
        // validate customer-details
        validateResult = validateResult.concat(
            doCompare(switchTypes("regulatory-checks"), res?.FirstCustomer, res?.SecondCustomer)
        );

        const isAllMatch = validateResult?.findIndex((e) => e === false); // > 0 means false, -1 means true
        if (isAllMatch >= 0) {
            setIsSubmit({
                isShow: true,
                msg: "All data from customers 1 and 2 must be matching before this process can be completed.",
                title: "Error",
                isReload: true,
            });
            setIsBusy(false);
            return;
        }

        // validate user id
        if (!validateActiveUsers(res?.FirstCustomer?.ActorUserId, res?.SecondCustomer?.ActorUserId)) {
            setIsSubmit({
                isShow: true,
                msg:
                    "Cannot submit process as the selected customers have >1 active user for the platform. Please ensure there is only 1 or 0 users tied to these customers in order to submit. Please refer to the adviser if this needs further clarification.",
                title: "Error",
                isReload: true,
            });
            setIsBusy(false);
            return;
        }

        // validate AML check statu
        const result = validateAMLCheckStatus(res?.FirstCustomer, res?.SecondCustomer);
        if (result.length !== 0) {
            const _string = join(result, ",");
            setIsSubmit({
                isShow: true,
                msg: `Please re-run the AML checks for the following customer as they have been flagged for not passing their latest AML check: ${_string}`,
                title: "Error",
                isReload: true,
            });
            setIsBusy(false);
            return;
        }

        CustomerMergeAction.mergeCustomer(fromCustomer, toCustomer, (res: Array<ServiceValidationError>) => {
            if (res.length == 0) {
                Navigator.navigateTo(Urls.get().main.CustomerMergeSelectCustomers, {
                    scrollAfterNavigating: true,
                    queryParamsObject: {
                        flag: 1,
                    },
                });
            } else {
                const errorMsg = res[0]?.UserMessage;
                switch (errorMsg) {
                    case "EC0260 Merge error (Category/Type/SubType)":
                        setIsSubmit({
                            isShow: true,
                            msg: `Merge not possible due to the difference in types of these customers set in the system.`,
                            title: "Error",
                            isReload: false,
                        });
                        setIsBusy(false);
                        break;
                    case "EC0260 Merge error (Roles)":
                        setIsSubmit({
                            isShow: true,
                            msg: `Merge not possible due to the roles held by these 2 customers.`,
                            title: "Error",
                            isReload: false,
                        });
                        setIsBusy(false);
                        break;
                    case "EC0260 Merge error (Relationships)":
                        setIsSubmit({
                            isShow: true,
                            msg: `Merge is not possible due to the relationship set in the system between these 2 customers.`,
                            title: "Error",
                            isReload: false,
                        });
                        setIsBusy(false);
                        break;
                    case "EC0260 Merge error (Owner Permissions)":
                        setIsSubmit({
                            isShow: true,
                            msg: `Merge not possible due to mismatch in permissions/security levels of these 2 customers.`,
                            title: "Error",
                            isReload: false,
                        });
                        setIsBusy(false);
                        break;
                    default:
                        console.error(errorMsg);
                        setIsSubmit({
                            isShow: true,
                            msg: `Merge not possible due to some unknown reasom.`,
                            title: "Error",
                            isReload: false,
                        });
                        setIsBusy(false);
                        break;
                }
            }
        });
    });
};

export const Declarations = (props: IDeclarationsProps) => {
    const [hasChecked, setHasChecked] = React.useState([]);
    const [isSubmit, setIsSubmit] = React.useState({ isShow: false, msg: "", title: "", isReload: false });
    const [isCancel, setIsCancel] = React.useState(false);
    const [isBusy, setIsBusy] = React.useState(false);
    return (
        <>
            <h2 className="mb-22">Declarations</h2>
            <CheckboxGroup
                type="block"
                wrapCss="mb-0"
                options={[
                    {
                        label:
                            "Authority to proceed has been provided by all interested stakeholders: adviser/end client/Standard Life. All the relevant doumentation has been recorded as required",
                        value: hasChecked.includes(1),
                        onChange: (v) => {
                            const checked = hasChecked;
                            if (v) {
                                setHasChecked(checked.concat(1));
                            } else {
                                setHasChecked(checked.filter((ele) => ele != 1));
                            }
                        },
                    },
                ]}
            />
            <CheckboxGroup
                type="block"
                wrapCss="mb-0"
                options={[
                    {
                        label: "I/We Confirm:",
                        value: hasChecked.includes(2),
                        onChange: (v) => {
                            const checked = hasChecked;
                            if (v) {
                                setHasChecked(checked.concat(2));
                            } else {
                                setHasChecked(checked.filter((ele) => ele != 2));
                            }
                        },
                    },
                ]}
            />
            <p className="ml-33">
                The impact of applying these changes has been clearly articulated to all relevant stakeholders.
                Specifically calling out the risk that this could result in a loss of access to accounts for individuals
                customers if not dealt with properly.
            </p>
            <CheckboxGroup
                type="block"
                wrapCss="mb-0"
                options={[
                    {
                        label: "Confirm all",
                        value: hasChecked?.length == 2,
                        onChange: (v) => {
                            if (v) {
                                setHasChecked([1, 2]);
                            } else {
                                setHasChecked([]);
                            }
                        },
                    },
                ]}
            />
            <div className="page-actions">
                <div className="action-secondary">
                    <button
                        onClick={() => {
                            setIsCancel(true);
                        }}
                        className="prev-button"
                    >
                        <span aria-hidden="true" className="icon"></span>
                        <span className="text">Cancel</span>
                    </button>
                </div>
                <div className="action-primary">
                    <button
                        className="btn primary"
                        onClick={() => {
                            submitMerge(props.data, setIsSubmit);
                        }}
                        disabled={hasChecked?.length != 2 || props.customerSelected.length != 1}
                    >
                        <span className="text">Submit</span>
                        <span className="icon" aria-hidden="true"></span>
                    </button>
                </div>
            </div>
            {isSubmit.isShow && (
                <Lightbox
                    show={isSubmit.isShow}
                    title={isSubmit.title}
                    unclosable={true}
                    onClose={() => {
                        setIsSubmit({ isShow: false, msg: "", title: "", isReload: false });
                    }}
                    cssWrapper="is-default-lightbox is-narrow"
                    contentCssCustom="pt-20"
                >
                    <p className="mb-10">{isSubmit.msg}</p>

                    <button
                        className={`btn secondary  mt-20 mr-20 ${isBusy ? "btn is-busy" : ""}`}
                        onClick={() => {
                            if (isSubmit?.isReload) {location.reload();}
                            setIsSubmit({ isShow: false, msg: "", title: "", isReload: false });
                        }}
                    >
                        {isSubmit.title == "Submit" ? "Cancel" : "OK"}
                    </button>

                    {isSubmit.title == "Submit" && (
                        <button
                            className={`btn primary  mt-20 ${isBusy ? "btn is-busy" : ""}`}
                            onClick={() => {
                                setIsBusy(true);
                                submit(props.customerSelected, setIsSubmit, setIsBusy);
                            }}
                        >
                            Submit
                        </button>
                    )}
                </Lightbox>
            )}
            {isCancel && (
                <Lightbox
                    show={isCancel}
                    title={"Cancel"}
                    unclosable={true}
                    onClose={() => {
                        setIsCancel(false);
                    }}
                    cssWrapper="is-default-lightbox is-narrow"
                    contentCssCustom="pt-20"
                >
                    <p className="mb-10">Are you sure you wish to cancel?</p>
                    {checkPermission(UserClaim.AdviserPortalCustomerFullyAccessReadWrite) && (
                        <button
                            className="btn primary  mt-20 mr-20"
                            onClick={() => {
                                window.location.href =
                                    "/wpadviser/en-gb/dashboard/home/main/admin/customer-merge/select-customers";
                            }}
                        >
                            Yes
                        </button>
                    )}
                    <button
                        className="btn secondary  mt-20"
                        onClick={() => {
                            setIsCancel(false);
                        }}
                    >
                        No
                    </button>
                </Lightbox>
            )}
        </>
    );
};
